import { createContext } from 'react';

interface EditorSaveContextType {
  /** Perform a silent save if content has changed */
  silentSave: () => Promise<void>;
  /** Check if editor content differs from Firebase */
  isDirty: () => boolean;
  /** Register editor callbacks (called by MarkdownEditor on mount) */
  registerEditor: (callbacks: EditorCallbacks | null) => void;
}

interface EditorCallbacks {
  getCurrentMarkdown: () => string;
  getLastExternalMarkdown: () => string | undefined;
  save: (markdown: string) => Promise<void>;
}

export const EditorSaveContext = createContext<EditorSaveContextType | null>(null);
